import * as angular from 'angular';
import {IController} from "angular";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";

export class DeliveryInfoButtonCtrl implements IController {
  delivery: any;

  /* @ngInject */
  constructor(private deliveriesDialogService: DeliveriesDialogService) {
  }

  $onInit() {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  open(delivery, event) {
    event.stopPropagation();
    this.deliveriesDialogService.serviceInfo(delivery, event);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryInfoButton', {
    bindings: {
      delivery: '<'
    },
    template: require('./delivery-info-button.html').default,
    controller: DeliveryInfoButtonCtrl
  });
